import React from 'react';

import InfoWillComeMessage from './InfoWillComeMessage';
import TransactionLineSkeleton from './TransactionLineSkeleton';

import './TransactionLine.scss';

interface TransactionLineProps<T> {
    label: string;
    value?: T;
    customValue?: React.ReactNode;
    formatter?: (v: T) => string;
    /**
     * @default false
     */
    showInfoMsgIfEmptyValue?: boolean;
    /**
     * @default false
     */
    isLoading?: boolean;
    /**
     * @default true
     */
    show?: boolean;
}

const defaultFormatter = <T,>(value: T) => String(value);
const TransactionLine = <T,>({
    label,
    value,
    customValue,
    formatter = defaultFormatter,
    showInfoMsgIfEmptyValue = false,
    isLoading = false,
    show = true,
}: TransactionLineProps<T>): JSX.Element => {
    if (!show) {
        return <></>;
    }
    if (isLoading) {
        return <TransactionLineSkeleton />;
    }
    if (value || customValue)
        return (
            <div className="transaction-details__detail">
                <div className="transaction-details__detail-label" data-testid="transaction-detail-labels">
                    {label}
                </div>
                <p className="transaction-details__detail-data">
                    {value && formatter(value)}
                    {customValue}
                </p>
            </div>
        );
    if (showInfoMsgIfEmptyValue)
        return (
            <div className="transaction-details__detail">
                <div className="transaction-details__detail-label">{label}</div>
                <InfoWillComeMessage />
            </div>
        );
    return <></>;
};
export default TransactionLine;
